module.exports = __webpack_public_path__ + "static/media/Illus-Seasonal@3x.082b56ea.png";